import axios from "axios";
import { useQuery } from "react-query";
import { API_ENDPOINT } from "../utils/constants";
import { getAuthHeader } from "../utils/util";

const useGetEmailTemplate = (id, type) => {
  return useQuery({
    queryKey: ["get-form-email-template", id],
    queryFn: async () => {
      const response = await axios.get(
        `${API_ENDPOINT}event/get-form-email-template?type=${type ? type : ""}`,
        getAuthHeader(id)
      );
      return response.data;
    },
    retry: (failureCount, error) => {
      if (!error.response) return true; // Retry on network errors
      const status = error.response.status;
      return status !== 401 && status !== 404 && status !== 500; // No retries for 404/500
    },
  });
};

export default useGetEmailTemplate;
